<mat-card class="filter">
  <div class="RoleType">
    <mat-form-field appearance="fill">
      <mat-label> {{typename}} Type</mat-label>
      <mat-select placeholder="Select {{typename}} Type" (selectionChange)="getSubFolderFields($event)"
        [(ngModel)]="selectedItems" name="selectedPeopleType">
        <mat-option *ngFor="let subFolder of subFolderList" [value]="subFolder.subFolderID">
          {{ subFolder.folderName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <button class="pptype" mat-button color="primary" (click)="openDialogWithRef(myDialog)">
    <mat-icon>add_circle</mat-icon> Create {{typename}} Type
  </button>
  <button mat-button class="addGroup" *ngIf="SuperAdminAdd==true && ImportFieldstoOtherOrg==true" (click)="openDialogImport(import)" color="primary">Import Fields to Other Org/Offices</button>
  <button mat-button class="addGroup" (click)="addEditGroup()" color="primary">Add Group</button>
  <button class="create" mat-flat-button color="primary" (click)="createField(createfilledSlide, 1)"> Create Field
  </button>
</mat-card>

<div class="documents">
  <mat-card cdkDropList [cdkDropListData]="drapDropList"  class="example-list rowholder" (cdkDropListDropped)="drop($event)"
    [cdkDropListConnectedTo]="dls">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldIcon"></span>
      <span class="fieldIcon"></span>
      <span class="fieldName">Name</span>
      <span class="fieldName availableOn">Available on</span>
      <span class="fieldControl">Field Type</span> 
      <span class="fieldType">Synonyms</span>    
      <span class="fieldType">Category</span>
      <span class="requried">Required</span>
      <span class="editField">Edit</span>
      <span class="delete">Deactivate</span>
    </div>
    <div class="example-box" *ngFor="let item of drapDropList ;let index1 = index" cdkDrag>      
      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>      
      <div class="fieldRow" *ngIf="!item.hasOwnProperty('length') ; else arrayView">

        <span class="moveicon" cdkDragHandle (mousedown)="getElementValue(item)" *ngIf="item.position == -1 || item.position == -2">
          <mat-icon>lock</mat-icon>
        </span>
        <span class="moveicon" cdkDragHandle (mousedown)="getElementValue(item)" *ngIf="item.position>=0">
          <mat-icon>drag_handle</mat-icon>
        </span>
        <span *ngIf="SuperAdminAdd==true" class="fieldIcon"> 
          <mat-checkbox (change)="checkFeilds($event,item)">            
          </mat-checkbox>
         </span>
        <span class="fieldIcon">
          <mat-icon>{{item.fieldIcon}}</mat-icon>
        </span>
        
        <span class="fieldName">{{item.fieldName}}</span>
        <span class="fieldName availableOn" *ngIf="item.availableOn == 1">{{typename}}</span>
        <span class="fieldName availableOn"*ngIf="item.availableOn == 2">Form</span>
        <span class="fieldName availableOn"*ngIf="item.availableOn == 3">Both</span>
        <span class="fieldControl">{{item.fieldTypeName}}</span>  
        
        <span class="fieldType" (click)="openDialogSynonyms(synonymsDialog,item)">
          <mat-icon matTooltipClass="tooltip" matTooltip="Synonym">sync
          </mat-icon>
        </span>  

        <span class="fieldType">         
          <mat-icon matTooltipClass="tooltip" *ngIf="item.fieldCategoryTypeID != 3 " matTooltip="Global">public
          </mat-icon>
          <mat-icon matTooltipClass="tooltip" *ngIf="item.fieldCategoryTypeID == 3 " matTooltip="Custom">account_box
          </mat-icon>
        </span>


        <span class="requried" *ngIf="item.fieldName == 'Name' || item.fieldName == 'Image'">
          <mat-slide-toggle color="primary" [disabled]="item.fieldID != 0" [checked]="item.isRequired">
          </mat-slide-toggle>
        </span>
       
        <span class="requried" *ngIf="item.fieldName != 'Name' && item.fieldName != 'Image'">
          <mat-slide-toggle color="primary"  [checked]="item.isRequired" (change)="changedToggle(item,$event)">
          </mat-slide-toggle>
        </span>

        <span class="editField">
          <button mat-icon-button class="editbtn"
            [disabled]="item.isNonEditable"
            (click)="editField(editfilledSlide, item, 1)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>

        <span class="delete">
          <button *ngIf="typename!='Task'" mat-icon-button class="trash"
            [disabled]="item.isNonDeactivated == true"
            (click)="deactivateField(item, false)">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>

          <button *ngIf="typename=='Task'" mat-icon-button class="trash"            
            (click)="deactivateField(item, false)">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>

        </span>

      </div>

      <ng-template #arrayView>
        <div class="groupholder" cdkDropList [cdkDropListData]="item" (cdkDropListDropped)="drop($event)"
          [cdkDropListConnectedTo]="dls">
          <div class="groupname">
            <div class="fieldRow">
              <span class="moveicon"  cdkDragHandle  *ngIf="item.length > 1">
                <mat-icon>drag_handle</mat-icon>
              </span>
              <span class="moveicon" cdkDragHandle *ngIf="item.length == 1">
                <mat-icon>lock</mat-icon>
              </span>
              <!-- <span *ngIf="SuperAdminAdd==true" class="fieldIcon"> 
               <mat-checkbox (change)="checkFeildsGroup($event,item)" ></mat-checkbox>
              </span> -->
              <span class="fieldIcon f{{index1}}" (click)="showSubGroup(index1,item)">
                <button mat-icon-button  class="right" ><mat-icon>keyboard_arrow_right</mat-icon></button>
                <button mat-icon-button class="down" ><mat-icon>keyboard_arrow_down</mat-icon></button> 
              </span>
              <span class="fieldName">
                <input type="text" maxlength="50" (change)="onChange($event,item)" value="{{item[0].groupName}}">
              </span>
              <span class="delete">
                <button mat-icon-button class="trash" (click)="DeleteGroup(item)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </span>
            </div>

          </div>  
          <div class="groupOuter group{{index1}}">
            <div class="fieldgroup"  >
              <div class="example-box" *ngFor="let innerItem of item; let i = index" cdkDrag
                (cdkDragEntered)="onDragEntered($event)" (cdkDragStarted)="onDragStarted($event)">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="fieldRow" [ngClass]="{'firstRow': i == 0 }">
                  <span class="moveicon" cdkDragHandle>
                    <mat-icon>drag_handle</mat-icon>
                  </span>
                 <span *ngIf="SuperAdminAdd==true" class="fieldIcon"> 
                 <mat-checkbox (change)="checkFeildsinnerItem($event,innerItem)"></mat-checkbox>
                 </span>
                  <span class="fieldIcon">
                    <mat-icon>perm_contact_calendar</mat-icon>
                  </span>

                  <span class="fieldName">{{innerItem.fieldName}}</span>
                  <span class="fieldName availableOn" *ngIf="innerItem.availableOn == 1">{{typename}}</span>
                  <span class="fieldName availableOn" *ngIf="innerItem.availableOn == 2">Form</span>
                  <span class="fieldName availableOn" *ngIf="innerItem.availableOn == 3">Both</span>
                  <span class="fieldControl">{{innerItem.fieldTypeName}}</span>                  

                  <span class="fieldType" (click)="openDialogSynonyms(synonymsDialog,innerItem)">
                    <mat-icon matTooltipClass="tooltip" matTooltip="Synonym">sync
                    </mat-icon>
                  </span>  

                  <span class="fieldType">
                   
                    <mat-icon matTooltipClass="tooltip" *ngIf="innerItem.fieldCategoryTypeID != 3 " matTooltip="Global">public
                    </mat-icon>
                    <mat-icon matTooltipClass="tooltip" *ngIf="innerItem.fieldCategoryTypeID == 3 " matTooltip="Custom">account_box
                    </mat-icon>
                  </span>
                  
                  <span class="requried">
                    <mat-slide-toggle color="primary" [checked]="innerItem.isRequired" (change)="changedToggle(innerItem,$event)">
                    </mat-slide-toggle>
                  </span>

                  <span class="editField">
                    <button mat-icon-button class="editbtn"  [disabled]="innerItem.isNonEditable"
                      (click)="editField(editfilledSlide, innerItem, 1)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </span>

                  <span class="delete">
                    <button *ngIf="typename!='Task'" mat-icon-button class="trash" [disabled]="innerItem.isNonDeactivated == true" 
                      (click)="deactivateField(innerItem, false)">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>

                    <button *ngIf="typename=='Task'" mat-icon-button class="trash" 
                      (click)="deactivateField(innerItem, false)">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>

                    <!-- "innerItem.fieldCategoryTypeID == 1" <button mat-icon-button class="trash" [disabled]="item.fieldID != 0"
                      (click)="deactivateField(item, false)">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button> -->
                  </span>
                </div>
              </div>

            </div>
          </div>


          <div class="blankGroup" *ngIf="item.length == 1 ">
            Drag fields here to add to section
          </div>
        </div>
      </ng-template> 

      
    </div>
  </mat-card>

<div class="deativeFields" *ngIf="DeactivatefieldsList.length > 0 ">
  <h3>Inactive Fields ({{DeactivatefieldsList.length}})</h3>
  
  <mat-card class="example-list rowholder">
    
    <div class="fieldRow head">   
      <span class="moveicon"></span>
      <span class="fieldIcon"></span>
      <span class="fieldName">Name</span>
      <!-- <span class="fieldControl">Field Type</span>  -->
      <span class="fieldType">Category</span>
      <span class="requried"></span>
      <span class="editField"></span>
      <span class="delete">Activate</span>

    </div>
    <div class="example-box fieldRow" *ngFor="let item of DeactivatefieldsList">
      <span class="moveicon" cdkDragHandle></span>
      <span class="fieldIcon">
        <mat-icon>{{item.fieldIcon}}</mat-icon>
      </span>
      <span class="fieldName">{{item.fieldName}}</span>   
      <span class="fieldControl">{{item.fieldTypeName}}</span>    

      <!-- <span class="fieldType" (click)="openDialogSynonyms(synonymsDialog,item)">
        <mat-icon matTooltipClass="tooltip" matTooltip="Synonym">sync
        </mat-icon>
      </span>  -->
      <span class="fieldType">
        <mat-icon matTooltipClass="tooltip" *ngIf="item.fieldCategoryTypeID != 3 " matTooltip="Global">public
        </mat-icon>
        <mat-icon matTooltipClass="tooltip" *ngIf="item.fieldCategoryTypeID == 3 " matTooltip="Custom">account_box
        </mat-icon>
      </span>
      <span class="requried"></span>
      <span class="editField"></span>
      <span class="delete">
        <button mat-icon-button class="trash" (click)="deactivateField(item, true)">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </span>
    </div>
  </mat-card>
</div>
 



</div>

<ng-template #import>
<h2 matDialogTitle>Import fields</h2>
<mat-dialog-content>
  <div class="table-header table-row">
    <div class="col_holder">
      <div class="td icon"></div>
      <div class="td">Organization Name</div>
      <div class="td">Organization Type</div>
      
    </div>
  </div>
  <div class="rowtable table-row" *ngFor="let row of organizationList; let rowIndex = index">
    <div class="table-row">
     <div class="col_holder">
          <div class="td icon">
            <span *ngIf="isRowClickable(rowIndex)">
            <span *ngIf="expanded[row.officeName]"><button (click)="expanded[row.officeName] = !expanded[row.officeName]" mat-icon-button color="basic" ><mat-icon>expand_less</mat-icon></button></span>
            <span *ngIf="!expanded[row.officeName]"><button (click)="expanded[row.officeName] = !expanded[row.officeName]" mat-icon-button color="basic" ><mat-icon>expand_more</mat-icon></button></span>
          </span>
        </div>
        <div class="td">
          <span class="fieldIcon popucheck">
          <mat-checkbox (change)="checkOrgization($event,row)"></mat-checkbox>
          </span>
          <span class="orgName" *ngIf="officeAdmin==false">{{row.officeName}}</span>          
          <span *ngIf="officeAdmin==true">{{row.officeName}}</span>          
          <span class="lbltag" *ngIf="row.isActive==false">Inactive</span>
          <span class="lbltag_active" *ngIf="row.isActive==true">Active</span>
        </div> 
       <div class="td">{{row.domainName}}</div> 
     </div>      
      <div [@detailExpand]="expanded[row.officeName] ? 'expanded' : 'collapsed'">
      
        <div  class="child-row" *ngFor="let childrow of row.offices">
          <div class="td icon"></div>
          <div class="td">
            <mat-icon color="primary">subdirectory_arrow_right</mat-icon>
             <span class="fieldIcon popucheck">
             <mat-checkbox [checked]="childrow.isChecked" (change)="checkOffice($event,childrow)"></mat-checkbox>
            </span>
            <span class="orgName">{{childrow.officeName}}</span>
            <span class="lbltag" *ngIf="childrow.isActive==false">Inactive</span>
            <span class="lbltag_active" *ngIf="childrow.isActive==true">Active</span>
          </div> 
           <div class="td"><span class="orgName">{{childrow.domainName}}</span>
          </div>     
        </div>
    </div>
    </div>
  </div>

  <div *ngIf="organizationListShow">  
    <p style="text-align: center; padding: 20px;">No Record Found</p>  
   </div>  

</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="close()">Close</button>
    <button mat-flat-button *ngIf="showImportButton==true" color="primary"
    (click)="ImportSelectedFieldsForOtherOffices()">
      Import
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #myDialog>
  <h2 matDialogTitle>Create {{typename}} Type</h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>{{typename}} Type</mat-label>
      <input matInput [(ngModel)]="subFolderName" maxlength="50" [ngModelOptions]="{ standalone: true }"
       placeholder="Create {{typename}} Type" (input)="onSearchChange($event.target.value)"
        value="" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="close()">Close</button>
    <button mat-button   [disabled]="!SubFolderButton" (click)="createSubFolder(subFolderName)" color="primary">
      Create
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #synonymsDialog>
  <div class="headerfeild">
    <h2 matDialogTitle>{{fieldName}}</h2>
  <button color="primary"  mat-icon-button (click)="addSynonyms()"><mat-icon>add</mat-icon></button>
  </div>
  <mat-dialog-content>
    
    <div class="codingTable" *ngIf="systemFeildsList.length>0">
      <table>
        <tr>          
          <th>Field Synonyms</th>
          <th class="action" >&nbsp;</th>
        </tr>

        <tr *ngFor="let item of systemFeildsList;let i = index">                 

         <td>    
            <input matInput [disabled]="item.isDeleted==false" type="text" [(ngModel)]="item.value"
            (input)="ontextChange($event.target.value)"  [ngClass]="{'fill': item.value}">           
        </td>


          <td class="action">  
            <button mat-icon-button class="mat-icon-buttton" (click)="removesystemField(item)"
            [disabled]="item.isDeleted==false">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
   
      </table>

     

    </div>

  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="close()">Close</button>

    <button mat-button color="primary"  [disabled]="SynonymsButton==true"  (click)="saveSynonyms()">Save</button>

  </mat-dialog-actions>
</ng-template>

